import { render } from "./DjiInBoundOrderCount.vue?vue&type=template&id=bfcd1b18&scoped=true"
import script from "./DjiInBoundOrderCount.vue?vue&type=script&lang=js"
export * from "./DjiInBoundOrderCount.vue?vue&type=script&lang=js"

import "./DjiInBoundOrderCount.vue?vue&type=style&index=0&id=bfcd1b18&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfcd1b18"]])

export default __exports__